import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Tooltip } from "../Tooltip/Tooltip.component";
import S from "./InputWrapper.module.scss";

interface PropsWithLabel {
    label: React.ReactNode;
    forId: string | undefined;
}

interface PropsWithoutLabel {
    label?: never;
    forId?: string;
}

interface PropsWithChildren {
    children: React.ReactNode;
}

interface PropsEssentials {
    helperText?: React.ReactNode;
    tooltip?: string;
    className?: string;
    invalid?: boolean;
    fullWidth?: boolean;
}

export type DA_InputWrapperProps = PropsEssentials & (PropsWithLabel | PropsWithoutLabel);

export type DA_InputWrapperInternalProps = DA_InputWrapperProps & PropsWithChildren;

export const DA_InputWrapper = ({
    label,
    forId,
    helperText,
    tooltip,
    className,
    invalid,
    fullWidth,
    children,
}: DA_InputWrapperInternalProps) => (
    <div className={cn(S.wrapper, className, fullWidth && S.fullWidth)}>
        {(label || tooltip) && (
            <div className={S.header}>
                {label && (
                    <label htmlFor={forId} className={S.label}>
                        {label}
                    </label>
                )}
                {tooltip && <DA_Tooltip className={S.tooltip} text={tooltip} />}
            </div>
        )}
        <div className={S.inputWrapper}>{children}</div>
        {helperText && <div className={cn(S.helperText, invalid && S.invalid)}>{helperText}</div>}
    </div>
);
